import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M21.09 8.524h-1.683c.205-.415.32-.882.32-1.376C19.727 5.409 18.302 4 16.545 4c-1.324 0-2.433.756-3.225 1.732a6.563 6.563 0 0 0-1.094 1.982 6.563 6.563 0 0 0-1.094-1.982c-.79-.976-1.9-1.731-3.223-1.731C6.151 4 4.728 5.41 4.728 7.149c0 .493.114.96.319 1.376H2.909A.907.907 0 0 0 2 9.43v4.523c0 .5.407.905.91.905h.908v7.237c0 .5.407.905.91.905h14.545c.502 0 .909-.405.909-.905v-7.237h.909c.502 0 .909-.405.909-.905V9.43c0-.5-.407-.906-.91-.906zm-7.137-.238c.2-.603.594-1.275 1.104-1.77.503-.487 1.01-.706 1.488-.706a1.35 1.35 0 0 1 1.363 1.339c0 .73-.6 1.338-1.363 1.338-.29 0-.598.01-.883.019h-.015c-.706.022-1.288.035-1.755-.02h-.005l.066-.2zM7.909 5.81c.479 0 .985.22 1.488.706.51.495.904 1.167 1.105 1.77l.066.199h-.005c-.468.056-1.049.042-1.755.02h-.015c-.284-.009-.593-.019-.883-.019a1.35 1.35 0 0 1-1.363-1.338c0-.73.6-1.338 1.363-1.338zm12.273 7.238h-1.819v8.142H5.637v-8.142H3.818v-2.714h16.364v2.714z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20.182 13.048h-1.819v8.142H5.637v-8.142H3.818v-2.714h16.364v2.714z",
  class: "background",
  fill: "#006241",
  "fill-opacity": "0"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}